export enum FullPageErrors {
  COULD_NOT_FETCH_VENDORS = 'Could not load vendors',
  REACT_CONTEXT_USED_OUTSIDE_PROVIDER = 'Context used outside provider',
  COULD_NOT_FETCH_VENDOR = 'Could not find vendor',
  COULD_NOT_FETCH_VENDOR_CURRENCY = 'Could not find vendor currency',
  COULD_NOT_FETCH_VENDOR_PERMALINK = 'Could not find vendor permalink',
  COULD_NOT_FETCH_AVAILABILITY_FOR_VENDOR = 'Could not find vendor menu',
  COULD_NOT_FETCH_CHECKOUT_BASKET = 'This basket no longer exists, please check your dashboard',
  CHECKOUT_BASKET_ITEMS_CHANGED = 'Please review these changes to continue with your order',
  COULD_NOT_FIND_MENU_ITEM_OF_BASKET_ITEM = 'could not find menu item',
  VENDOR_LOCATION_DOES_NOT_MATCH_VENDOR = 'Vendor location does not match vendor',
  CHECKOUT_VALIDATION_FAILED = 'Validation failed',
  CHECKOUT_BASKET_ACCOUNT_INVALID_FOR_USER = 'This basket id does not belong to you',
  CHECKOUT_BASKET_ACCOUNT_INVALID_PAYMENT_METHODS = 'Could not load payment methods',
  SUPPLIER_DIFFERENT_MARKETPLACE = "Whoops, you're trying to access a supplier from a different marketplace.",
}
